export const QUINCENA = [
  { id: '1', name: '01 - PRIMERA' },
  { id: '2', name: '02 - SEGUNDA' }
];
